import eventBus from "@/util/eventBus";
import {uniqueId} from '@/util'
let startPoint = null
let startItem = null
let endPoint = null
let activeItem = null
let curInPoint = null
export default {
  getEvents() {
    return {
      mousemove: 'onMousemove',
      mouseup: 'onMouseup',
      'node:mouseover': 'onMouseover',
      'node:mouseleave': 'onMouseleave'
    };
  },
  onMouseup(e) {
    const item = e.item
    if (item && item.getType() === 'node') {
      const group = item.getContainer();
      if (e.target.attrs.isInPoint) {
        const children = group.cfg.children
        children.map(child => {
          if (child.attrs.isInPointOut && child.attrs.parent === e.target.attrs.id) {
            activeItem = child
          }
        })
        curInPoint = e.target
      } else if (e.target.attrs.isInPointOut) {
        activeItem = e.target
        const children = group.cfg.children
        children.map(child => {
          if (child.attrs.isInPoint && child.attrs.id === e.target.attrs.parent) {
            curInPoint = child
          }
        })
      }
      if (activeItem) {
        const endX = parseInt(curInPoint.attrs.x);
        const endY = parseInt(curInPoint.attrs.y);
        endPoint = {x: endX, y: endY};
        if (this.edge) {
          this.graph.removeItem(this.edge)
          const model = {
            id: 'edge' + uniqueId(),
            source: startItem,
            target: item,
            sourceId: startItem._cfg.id,
            targetId: item._cfg.id,
            start: startPoint,
            end: endPoint,
            type: 'customEdge',
          };
          let name = startItem._cfg.model.name
          if (name === 'DTMF节点' || name === 'HTTP节点') {
            model.label = '分支-' + uniqueId();
          } else {
            model.label = '新意图-'+uniqueId();
          }
          eventBus.$emit('addItem', model);
        }
      } else {
        if (this.edge) {
          this.graph.removeItem(this.edge)
        }
      }
    } else {
      if (this.edge) {
        this.graph.removeItem(this.edge)
      }
    }
    this.graph.find('node',node=>{
      const group = node.get('group')
      const children = group.cfg.children
      children.map(child => {
        if (child.attrs.isInPointOut) {
          child.attr('opacity','0')
        }
        if (child.attrs.isInPoint) {
          child.attr('opacity','0')
        }
        if (child.attrs.isOutPoint) {
          child.attr('opacity', '0')
          child.attr('fill', '#fff')
        }
      })
    })
    if (startItem) {
      this.graph.setItemState(startItem,'hover',false)
    }
    this.graph.paint()
    startPoint = null
    startItem = null
    endPoint = {}
    activeItem = null
    curInPoint = null
    this.graph.setMode('default')
  },
  onMousemove(e) {
    const item = e.item
    if (!startPoint) {
      this.graph.find('node', node => {
        const group = node.get('group')
        const children = group.cfg.children
        children.map(child => {
          if (child.attrs.isInPointOut) {
            child.attr('opacity', '0.3')
          }
          if (child.attrs.isInPoint) {
            child.attr('opacity', '1')
          }
        })
      });
      const startX = parseInt(e.target.attrs.x);
      const startY = parseInt(e.target.attrs.y);
      startPoint = {x: startX, y: startY};
      startItem = item;
      this.edge = this.graph.addItem('edge', {
        source: item,
        target: item,
        start: startPoint,
        end: startPoint,
        type: 'link-edge'
      });
    } else {
      const point = {x:e.x, y: e.y}
      if (this.edge) {
        this.graph.updateItem(this.edge, {
          target: point
        });
      }
    }
  },
  onMouseover(e) {
    const item = e.item
    if (item && item.getType() === 'node') {
      if (e.target.attrs.isInPointOut && !this.hasTran) {
        this.hasTran = true
        /*e.target.transform([
          ['t',0,3],
          ['s',1.2,1.2]
        ])*/
      }
      this.graph.paint()
    }
  },
  onMouseleave() {
    this.graph.find('node', node => {
      const group = node.get('group')
      const children = group.cfg.children
      children.map(child => {
        if (child.attrs.isInPointOut) {
          child.resetMatrix()
        }
      });
    });
    this.hasTran = false
    this.graph.paint()
  }
}



// WEBPACK FOOTER //
// ./src/components/flow/components/behavior/add-edge.js